<template>
  <tr>
    <td colspan="3" class="text-left">
      <div class="confection-inputs">
        <basic-input
          validationRule="required|max:50"
          name="confection-envelope-layout"
          labelClass="mb-2"
          label="Sposób ułożenia kopert"
          description="Opisz w jaki sposób mamy ułożyć karty w paczce"
          placeholder="np. alfabetycznie według nazwisk"
          inputType="text"
          v-model="envelopeLayout"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import BasicInput from '../Inputs/basicInput.vue';

export default {
  name: 'NDEConfectionEnvelopeLayoutForm',
  components: {
    BasicInput,
  },
  computed: {
    ...mapFields('confection', ['envelopeLayout']),
  },
};
</script>
